export default __webpack_public_path__ + "static/7b40151dd53c4456a3aeca1405a259dd.jpg";